import wixWindow from 'wix-window';

$w.onReady(function () {
    $w("#header1").style.backgroundColor = "rgba(0,0,0,0.0)";

	if(wixWindow.formFactor === "Mobile"){
	$w("#box1").show();
	$w("#box2").show();
	$w("#box3").show();
	$w("#box4").show();
	$w("#box5").show();
    $w("#header1").style.backgroundColor = "#007BBD";
}});
